import React, { useEffect, useRef, useState } from 'react';
import wechatArrowUpWhiteIcon from '@/assets/images/icons/wechat-arrow-up-white.svg';

export type WechatActionTipsType = 'send' | 'share' | 'star' | 'collect';

export interface WechatActionTipsProps {
  action: WechatActionTipsType;
  className?: string;
  onClose?: () => void;
}

const ACTION_TEXT_MAP: Record<WechatActionTipsType, string> = {
  send: '转发给朋友',
  share: '分享到朋友圈',
  star: '星标',
  collect: '收藏',
};

export function WechatActionTips({ action, className, onClose }: WechatActionTipsProps) {
  const [isClosing, setIsClosing] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const closeTimerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) {
        window.clearTimeout(closeTimerRef.current);
      }
    };
  }, []);

  const handleDismiss = () => {
    if (isClosing || isHidden) {
      return;
    }

    setIsClosing(true);
    closeTimerRef.current = window.setTimeout(() => {
      setIsHidden(true);
      onClose?.();
    }, 240);
  };

  if (isHidden) {
    return null;
  }

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="关闭微信操作提示"
      className={[
        'fixed inset-0 z-[120] cursor-pointer bg-black/55 backdrop-blur-sm transition-opacity duration-200',
        isClosing ? 'opacity-0' : 'opacity-100',
        className ?? '',
      ].join(' ')}
      onClick={handleDismiss}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleDismiss();
        }
      }}
    >
      <div className="absolute right-4 top-4 flex flex-col items-end text-right text-white">
        <img src={wechatArrowUpWhiteIcon} alt="" className="mb-1 h-6 w-6 object-contain" />
        <p className="text-lg mb-2">点击上方“...”</p>
        <p className="text-lg ">选择“{ACTION_TEXT_MAP[action]}”</p>
      </div>
    </div>
  );
}
